// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var driverRouter = {
  path: '/driver',
  component: Layout,
  redirect: '/driver/list',
  name: 'Driver',
  meta: {
    title: '司机信息',
    icon: 'el-icon-s-custom',
    noCache: true,
    alwaysShow: true
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/driver/list/index');
    },
    name: 'DriverList',
    meta: {
      title: '司机信息',
      noCache: true,
      affix: false,
      icon: 'el-icon-s-custom',
      perms: 'admin:driver:list'
    }
  }, {
    path: 'create',
    component: function component() {
      return import('@/views/driver/list/edit');
    },
    name: 'DriverCreate',
    meta: {
      title: '新增司机',
      noCache: true,
      affix: false,
      icon: 'el-icon-s-custom',
      perms: 'admin:driver:save',
      hidden: true,
      activeMenu: '/driver/list'
    }
  }, {
    path: 'edit/:id',
    component: function component() {
      return import('@/views/driver/list/edit');
    },
    name: 'DriverEdit',
    meta: {
      title: '编辑司机',
      noCache: true,
      affix: false,
      icon: 'el-icon-s-custom',
      perms: 'admin:driver:update',
      hidden: true,
      activeMenu: '/driver/list'
    }
  }]
};
export default driverRouter;